<template>
  <button class="social-button" :class="social">
    <component :is="socialList[social].icon" class="social-button__icon" />
    {{ $t(socialList[social].text) }}
  </button>
</template>

<script setup>
import GoogleLogo from '~/assets/icons/googleLogo.svg';
import AppleLogo from '~/assets/icons/appleLogo.svg';

const { social } = defineProps({
  social: {
    type: String,
    required: true,
    validator(value) {
      return ['google', 'apple'].includes(value);
    },
  },
});

const socialList = {
  google: {
    icon: GoogleLogo,
    text: 'button.sign_in_with_google',
  },
  apple: {
    icon: AppleLogo,
    text: 'button.sign_in_with_apple',
  },
};
</script>

<style lang="scss">
@use '@/assets/styles/setup/variables.scss' as *;
@use '@/assets/styles/setup/mixins.scss' as *;

.social-button {
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;
  padding: 16px 30px;
  transition: background-color 0.2s;

  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.05em;

  @include tablet {
    padding: 12px 30px;
  }

  &.google {
    background: $color-gray-20;
    color: $color-black;

    &:hover {
      background: $color-gray-35;
    }
  }

  &.apple {
    background: $color-black;
    color: $color-white;
  }

  &__icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>
